/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicWebclientBarbersQueryResponse, GetApiPublicWebclientBarbersQueryParams, GetApiPublicWebclientBarbers400, GetApiPublicWebclientBarbers404 } from "../entities/GetApiPublicWebclientBarbers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicWebclientBarbers } from "../api/getApiPublicWebclientBarbers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicWebclientBarbersQueryKey = (params: GetApiPublicWebclientBarbersQueryParams) => [{ url: '/api/public/webclient/barbers' }, ...(params ? [params] : [])] as const

export type GetApiPublicWebclientBarbersQueryKey = ReturnType<typeof getApiPublicWebclientBarbersQueryKey>

export function getApiPublicWebclientBarbersQueryOptions(params: GetApiPublicWebclientBarbersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicWebclientBarbersQueryKey(params)
        return queryOptions<GetApiPublicWebclientBarbersQueryResponse, ResponseErrorConfig<GetApiPublicWebclientBarbers400 | GetApiPublicWebclientBarbers404>, GetApiPublicWebclientBarbersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicWebclientBarbers(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Активные мастера компании выбранной услуги из филиалов, где эта услуга продаётся, с ближайшим доступным слотом. Время рассчитывается по 30-минутным слотам
 * @summary Получить доступных мастеров (онлайн-запись)
 * {@link /api/public/webclient/barbers}
 */
export function useGetApiPublicWebclientBarbers<TData = GetApiPublicWebclientBarbersQueryResponse, TQueryData = GetApiPublicWebclientBarbersQueryResponse, TQueryKey extends QueryKey = GetApiPublicWebclientBarbersQueryKey>(params: GetApiPublicWebclientBarbersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicWebclientBarbersQueryResponse, ResponseErrorConfig<GetApiPublicWebclientBarbers400 | GetApiPublicWebclientBarbers404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicWebclientBarbersQueryKey(params)
         

         const query = useQuery({
          ...getApiPublicWebclientBarbersQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiPublicWebclientBarbers400 | GetApiPublicWebclientBarbers404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}